import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.19189 2.02343L6.79189 0.517757L12.3919 2.02343V8.9387L6.79189 10.8905L1.19189 8.9387V2.02343Z",
  fill: "url(#paint0_radial_3088_116547)",
  stroke: "#FF7171"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("radialGradient", {
    id: "paint0_radial_3088_116547",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.79189 0.728936) rotate(90) scale(10.6911 11.4213)"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#484125" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#2A291E"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }